export default __webpack_public_path__ + "static/media/instagram.e6f61fa3.svg";